/* tslint:disable */
/* eslint-disable */
/**
 * Prebooking service API
 * Service provides pre booking functionality for long term reservations.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * TnC tracking event
 * @export
 * @interface TnCTrackingEventDto
 */
export interface TnCTrackingEventDto {
    /**
     * 
     * @type {number}
     * @memberof TnCTrackingEventDto
     */
    roamingLegalEntity: number;
    /**
     * 
     * @type {string}
     * @memberof TnCTrackingEventDto
     */
    jwtToken: string;
}

/**
 * Check if a given object implements the TnCTrackingEventDto interface.
 */
export function instanceOfTnCTrackingEventDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "roamingLegalEntity" in value;
    isInstance = isInstance && "jwtToken" in value;

    return isInstance;
}

export function TnCTrackingEventDtoFromJSON(json: any): TnCTrackingEventDto {
    return TnCTrackingEventDtoFromJSONTyped(json, false);
}

export function TnCTrackingEventDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TnCTrackingEventDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'roamingLegalEntity': json['roamingLegalEntity'],
        'jwtToken': json['jwtToken'],
    };
}

export function TnCTrackingEventDtoToJSON(value?: TnCTrackingEventDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'roamingLegalEntity': value.roamingLegalEntity,
        'jwtToken': value.jwtToken,
    };
}

